import { TaskRecord, TaskStatus } from "./Task";

export enum TaskCollectionType {
    STANDARD_JOB = 0,
    CHARGING_JOB,
    RESEND_JOB,
}

export const rMapTaskCollectionType = {
    0: "Delivery Job",
    1: "Charging Job",
    2: "Resend Job",
}

export type TaskRecordCollectionSendData = {
    name: string,
    status: TaskStatus,
    createdDatetime?: Date | null,
    assignedDatetime?: Date | null,
    endDatetime?: Date | null,
    taskRecords: TaskRecord[],
    sourceLocation: number,
    targetLocation: number,
    taskCollectionType: TaskCollectionType,
    compartmentIndex: number,
    parentTaskRecord?: number,
}

export type TaskRecordCollectionRecord = {
    id: number,
    taskRecord: number,
    sequence: number,
    taskRecordCollection: number
}

export type TaskRecordCollectionData = {
    id: number,
    name: string,
    status: TaskStatus,
    createdDatetime?: Date | null,
    assignedDatetime?: Date | null,
    endDatetime?: Date | null,
    taskRecords: TaskRecordCollectionRecord[],
    sourceLocation: number,
    targetLocation: number,
    taskCollectionType: TaskCollectionType,
    compartmentIndex: number,
    progressIndex: number,
    waitTime: string,
    parentTaskRecord?: number,
}

export type TaskRecordCollectionDetailedData = {
    id: number,
    name: string,
    status: TaskStatus,
    createdDatetime?: Date | null,
    assignedDatetime?: Date | null,
    endDatetime?: Date | null,
    taskRecords: TaskRecord[],
    sourceLocation: number,
    targetLocation: number,
    taskCollectionType: TaskCollectionType,
    compartmentIndex: number,
    progressIndex: number,
    waitTime: string,
    parentTaskRecord?: number,
}